export default __webpack_public_path__ + "static/piercing-story-3-d988c39030ec88f00429600ee560591b.jpg";